<script>
import Layout from "@/views/layouts/main.vue";

export default {
  components: {Layout},
  data() {
    return {
      data: [],
    }
  },
  methods: {
  },
  computed: {
  }
}
</script>

<template>
  <Layout>
    <b-row>
      <b-col cols="10">
      </b-col>
      <b-col class="d-flex flex-column gap-2">
        <b-button variant="primary">複数廃棄物収集運搬作業</b-button>
        <b-button variant="primary">凝集汚泥収集運搬作業</b-button>
        <b-button variant="primary">ケミカルタンク清掃作業</b-button>
        <b-button variant="primary">蛍光灯搬入作業積替保管</b-button>
      </b-col>
    </b-row>
  </Layout>
</template>

<style scoped lang="scss">

</style>
